import Immutable from 'seamless-immutable';
import { RETRIEVE_CHANGE_OFFER_ELIGIBILITY_RULES } from './actions/customer.offering.actions';
export var INITIAL_STATE = Immutable({
  changeOfferEligibilityRules: [],
  changeOfferEligibilityRulesError: null,
  data: null,
  isLoadingOfferings: false,
  isLoadingChangeOfferEligibilityRules: false,
  offeringError: null
});
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    _ref$payload = _ref.payload,
    payload = _ref$payload === void 0 ? {} : _ref$payload,
    type = _ref.type;
  switch (type) {
    case RETRIEVE_CHANGE_OFFER_ELIGIBILITY_RULES.BEGIN:
      return state.set('isLoadingChangeOfferEligibilityRules', true);
    case RETRIEVE_CHANGE_OFFER_ELIGIBILITY_RULES.SUCCESS:
      return state.set('isLoadingChangeOfferEligibilityRules', false).set('changeOfferEligibilityRulesError', null).set('changeOfferEligibilityRules', payload.ChangeOfferEligibilityDetails);
    case RETRIEVE_CHANGE_OFFER_ELIGIBILITY_RULES.FAILURE:
      return state.set('changeOfferEligibilityRulesError', {
        code: payload.Code,
        message: payload.Message,
        severity: payload.Severity
      }).set('isLoadingChangeOfferEligibilityRules', false);
    default:
      return state;
  }
});